import { LOGO } from "@/lib/content";

const W = 1080;
const H = 1920;
const SERIF = '"Cormorant Garamond", Georgia, serif';
const SANS = "Montserrat, Arial, sans-serif";

const loadImg = (src) =>
  new Promise((res) => {
    const i = new Image();
    i.onload = () => res(i);
    i.onerror = () => res(null);
    i.src = src;
  });

function wrap(ctx, text, maxW) {
  const words = text.split(/\s+/).filter(Boolean);
  const lines = [];
  let cur = "";
  words.forEach((w) => {
    const t = cur ? `${cur} ${w}` : w;
    if (ctx.measureText(t).width > maxW && cur) {
      lines.push(cur);
      cur = w;
    } else cur = t;
  });
  if (cur) lines.push(cur);
  return lines;
}

function spaced(ctx, text, x, y, spacing) {
  ctx.letterSpacing = `${spacing}px`;
  ctx.fillText(text, x, y);
  ctx.letterSpacing = "0px";
}

function frame(ctx) {
  ctx.fillStyle = "#070605";
  ctx.fillRect(0, 0, W, H);
  const g = ctx.createRadialGradient(540, 330, 20, 540, 330, 760);
  g.addColorStop(0, "rgba(199,154,75,0.30)");
  g.addColorStop(1, "rgba(199,154,75,0)");
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = "#8a6328";
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.roundRect(48, 48, W - 96, H - 96, 40);
  ctx.stroke();
  ctx.strokeStyle = "rgba(199,154,75,0.3)";
  ctx.beginPath();
  ctx.roundRect(64, 64, W - 128, H - 128, 30);
  ctx.stroke();
}

function goldFill(ctx, y0, y1) {
  const g = ctx.createLinearGradient(300, y0, 780, y1);
  g.addColorStop(0, "#a87a35");
  g.addColorStop(0.5, "#f3dc9e");
  g.addColorStop(1, "#c79a4b");
  return g;
}

export async function drawPass(canvas, { centro, citta, provincia }) {
  await Promise.all([
    document.fonts.load(`600 120px ${SERIF}`),
    document.fonts.load(`italic 500 56px ${SERIF}`),
    document.fonts.load(`500 30px ${SANS}`),
    document.fonts.load(`600 30px ${SANS}`),
  ]).catch(() => null);
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");
  frame(ctx);
  ctx.textAlign = "center";
  const logo = await loadImg(LOGO);
  if (logo) ctx.drawImage(logo, 540 - 280, 150, 560, (560 * logo.height) / logo.width);

  ctx.fillStyle = "#c79a4b";
  ctx.font = `600 32px ${SANS}`;
  spaced(ctx, "PASS · ACCESSO RISERVATO", 540, 360, 10);
  spaced(ctx, "ALLE TITOLARI", 540, 402, 10);
  ctx.fillStyle = "#f3dc9e";
  ctx.save();
  ctx.translate(540, 462);
  ctx.rotate(Math.PI / 4);
  ctx.fillRect(-13, -13, 26, 26);
  ctx.restore();

  ctx.font = `600 128px ${SERIF}`;
  let lines = wrap(ctx, centro || "Il tuo centro", 860);
  if (lines.length > 3) {
    ctx.font = `600 96px ${SERIF}`;
    lines = wrap(ctx, centro, 880).slice(0, 4);
  }
  const lh = lines.length > 3 ? 98 : 122;
  let y = 610;
  ctx.fillStyle = "#fdf6e3";
  lines.forEach((l) => {
    ctx.fillText(l, 540, y);
    y += lh;
  });
  y += -lh + 78;
  ctx.fillStyle = "#b9ab93";
  ctx.font = `500 34px ${SANS}`;
  spaced(ctx, [citta, provincia].filter(Boolean).join(" · ").toUpperCase(), 540, y, 6);

  y += 130;
  ctx.fillStyle = "#f4ede1";
  ctx.font = `italic 500 58px ${SERIF}`;
  ctx.fillText("partecipa al workshop Natural Anti-Age", 540, y);
  ctx.font = `600 132px ${SERIF}`;
  ctx.fillStyle = goldFill(ctx, y, y + 260);
  ctx.fillText("Metodo", 540, y + 135);
  ctx.fillText("Skin Lovers", 540, y + 255);
  ctx.fillStyle = "#c79a4b";
  ctx.font = `500 30px ${SANS}`;
  spaced(ctx, "NATURAL ANTI-AGE", 540, y + 335, 6);
  spaced(ctx, "ESTETICA RIGENERATIVA NON INVASIVA", 540, y + 375, 6);

  ctx.strokeStyle = "rgba(199,154,75,0.6)";
  ctx.setLineDash([8, 6]);
  ctx.beginPath();
  ctx.moveTo(70, 1490);
  ctx.lineTo(W - 70, 1490);
  ctx.stroke();
  ctx.setLineDash([]);

  [["DATE", "25 · 26", "novembre"], ["FORMAT", "2 serate", "live"], ["RELATRICI", "Valentina", "& Renata"]].forEach(([k, a, b], i) => {
    const x = 265 + i * 275;
    ctx.fillStyle = "#a07a3c";
    ctx.font = `600 26px ${SANS}`;
    spaced(ctx, k, x, 1565, 5);
    ctx.fillStyle = "#f3dc9e";
    ctx.font = `600 54px ${SERIF}`;
    ctx.fillText(a, x, 1635);
    ctx.fillText(b, x, 1690);
  });

  const num = String(Math.abs([...(centro || "x")].reduce((h, c) => (h * 31 + c.charCodeAt(0)) | 0, 7)) % 9000 + 100).padStart(4, "0");
  ctx.font = `500 26px ${SANS}`;
  ctx.fillStyle = "#b9ab93";
  ctx.textAlign = "left";
  spaced(ctx, `PASS N. ${num}`, 140, 1770, 5);
  ctx.textAlign = "right";
  ctx.fillStyle = "#c79a4b";
  spaced(ctx, "#METODOSKINLOVERS", W - 140, 1770, 5);
  return canvas.toDataURL("image/png");
}
